// extracted by mini-css-extract-plugin
module.exports = {"CollapsedMenuHeader":"CollapsedMenuHeader___3Xq0k","DropdownMenu":"DropdownMenu___1COw-","CollapsedMenu":"CollapsedMenu___2w6pD","switchLocalButton":"switchLocalButton___3t39i"};